import { useTranslation } from "react-i18next";
import { NFPlainNumber } from "../../../Shared/NewForms/NFPlainNumber";
import { NFLookupUnit } from "../../../Shared/NewForms/NFLookupUnit";
import { NFLookupProduct } from "../../../Shared/NewForms/NFLookupProduct";
import { NFLookupCurrency } from "../../../Shared/NewForms/NFlookupCurrency";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { useState } from "react";
import { AppServices } from "../../../../config/entities";
import DropDownButton, { Item } from "devextreme-react/drop-down-button";
import { Button } from "react-bootstrap";
import { Popup } from "devextreme-react";
import { NFLookupVendorInvoice } from "../../../Shared/NewForms/NFLookupVendorInvoice";
import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { SetItemsPricesTable } from "./SetItemsPricesTable";

export interface AllItemsData {
  newPrice?: number;
  oldPrice?: number;
  percent?: number;
  productId?: string;
  unitId?: string;
  fillType?: number;
}

export const SetItemsPricesDetailsRecords = () => {
  const allPrice = {
    fillType: 0,
    groupId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    companyId: "0a30637e-6156-4c85-8e38-86c8ffdb30a3",
    vendorInvoiceId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  };

  const byGroup = {
    fillType: 1,
    groupId: "9f452a07-73c4-4843-9944-7fd4d3c22df4",
    companyId: "0a30637e-6156-4c85-8e38-86c8ffdb30a3",
    vendorInvoiceId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  };

  const byVendorInvoice = {
    fillType: 2,
    vendorInvoiceId: "9cb4a702-3a60-40a4-b6e0-d85ad91c5996",
  };
  const [showData, setShowData] = useState(false);
  const [showAllItemsData, setShowAllItemsData] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [data, setData] = useState<AllItemsData[]>([]);
  const [selectedOption, setSelectedOption] = useState<AllItemsData | null>(
    null
  );
  const tableName = "products";
  const { t } = useTranslation();
  const fetchData = async (requestData: any) => {
    try {
      const response = await AppServices.Axios.post(
        "/SetItemsPrices/GetProductsWithPrice",
        requestData
      );
      console.log(response.data);
      setData(response.data);
    } catch (err) {
      console.log(err);
    }
  };

  const setAllProductsHandler = () => {
    setShowAllItemsData(true);
    fetchData(allPrice);
  };

  const setByGroupHandler = () => {
    fetchData(byGroup);
  };
  const setByVendorInvoiceHandler = () => {
    fetchData(byVendorInvoice);
  };

  const onHiding = () => {
    setIsPopupVisible(false);
  };

  const calculateNewPrice = (oldPrice: any, percent: any) => {
    return oldPrice + (oldPrice * percent) / 100;
  };

  const updatePercentageHandler = (newPercentage: number, rowIndex: number) => {
    const updatedData = [...data];
    updatedData[rowIndex].percent = newPercentage;
    updatedData[rowIndex].newPrice = calculateNewPrice(
      updatedData[rowIndex].oldPrice,
      newPercentage
    );
    setData(updatedData);
  };

  return (
    <div>
      <NFormTable
        getData={data}
        showData={showData}
        fieldArray={tableName}
        showTable={showAllItemsData}
        toolBar={
          <>
            <DropDownButton
              text="Fill With"
              stylingMode="text"
              hoverStateEnabled={false}
              className="btn btn-sm btn-primary mb-3 me-3 custom-table-button"
              height={28}
              width={120}
              onItemClick={() => setShowData(true)}
            >
              <Item text="All items" onClick={setAllProductsHandler} />
              <Item text="Product group" onClick={setByGroupHandler} />
              <Item text="Vendor invoice" onClick={setByVendorInvoiceHandler} />
            </DropDownButton>
            <Button variant="" className="btn btn-sm btn-primary mb-3">
              Calculate
            </Button>
          </>
        }
      >
        <NFPlainNumber fieldName={"lineNo"} title={t("#")} width={50} />
        <NFLookupProduct
          fieldName={"productId"}
          title={t("Product")}
          required={true}
        />
        <NFLookupUnit fieldName={"unitId"} title={t("Unit measure")} />
        <NFIntInput fieldName={"oldPrice"} title={t("Old price")} />
        <NFIntInput
          fieldName={"percent"}
          title={t("%")}
          onValueChanged={(newPercentage, index) => {
            updatePercentageHandler(newPercentage, index);
          }}
        />
        <NFIntInput fieldName={"newPrice"} title={t("New price")} />
        <NFLookupCurrency fieldName={"currencyId"} title={"Currency"} />
      </NFormTable>

      <Popup
        visible={isPopupVisible}
        onHiding={() => {
          onHiding();
          setSelectedOption(null);
        }}
        showCloseButton={false}
        showTitle={true}
        resizeEnabled={true}
        dragEnabled={true}
        hideOnOutsideClick={true}
        onHidden={onHiding}
        dragOutsideBoundary={true}
        width={"auto"}
        height={"auto"}
        title={
          selectedOption?.fillType === 1
            ? "Select Group"
            : "Select Vendor Invoice"
        }
      >
        {selectedOption?.fillType === 1 && (
          <NFLookupProduct
            fieldName={"productId"}
            title={t("Product")}
            required={true}
          />
        )}
        {selectedOption?.fillType === 2 && (
          <NFLookupVendorInvoice
            fieldName={"vendorInvoiceId"}
            title={t("VendorInvoice")}
          />
        )}
        <div className="d-flex justify-content-between">
          <button className="btn btn-primary ">Apply</button>
          <button className="btn btn-secondary" onClick={onHiding}>
            Close
          </button>
        </div>
      </Popup>
    </div>
  );
};
